// Copy shown when a phone number has opted out of SMS (texted "STOP"). Surfaced
// as the disabled-option tooltip in the composer's "To" selector and next to the
// disabled send button.
export const OPTED_OUT_SMS_MESSAGE =
  "This number has opted out of SMS messages and cannot be texted. They can text START to opt back in.";

// Canonical comparison key for a phone number. Opt-out numbers arrive from
// comm-service as E.164 (+1XXXXXXXXXX) while a contact's stored phones may be
// 10-digit, 11-digit, or E.164 strings — reduce both sides to the same digits
// (dropping a leading US country code) so the comparison is format-agnostic.
const normalizePhoneForOptOut = (phone: string | null | undefined): string => {
  const digits = (phone ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  return digits;
};

export const buildOptedOutSet = (
  optedOutNumbers: string[] | undefined
): Set<string> => new Set((optedOutNumbers ?? []).map(normalizePhoneForOptOut));

export const isPhoneOptedOut = (
  phone: string | null | undefined,
  optedOutSet: Set<string>
): boolean => {
  const key = normalizePhoneForOptOut(phone);
  return key.length > 0 && optedOutSet.has(key);
};
